import { render, staticRenderFns } from "./MenuItemsDraggableNode.vue?vue&type=template&id=69f0196c&scoped=true&"
import script from "./MenuItemsDraggableNode.vue?vue&type=script&lang=js&"
export * from "./MenuItemsDraggableNode.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemsDraggableNode.vue?vue&type=style&index=0&id=69f0196c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f0196c",
  null
  
)

export default component.exports